import * as React from 'react';
import {getLayout, LayoutSize, onLayoutChange} from './layoutUtils';

export default class extends React.Component<any, any> {
    state = {
        layout: getLayout()
    };

    private unsubscribe: () => any;

    componentDidMount() {
        this.unsubscribe = onLayoutChange(() => this.setState({layout: getLayout()}));
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    render() {
        return this.props.children({
            layout: this.state.layout,
            isDesktop: this.state.layout === LayoutSize.DESKTOP,
            isTablet: this.state.layout === LayoutSize.TABLET,
            isMobile: this.state.layout === LayoutSize.MOBILE,
        });
    }
}



// WEBPACK FOOTER //
// ./resources/modules/cars/rating/tires/utils/LayoutAware.tsx